import { HTTPError } from 'ky';
import { useMutation } from '@tanstack/react-query';
import { ShopTypes } from '~/lib/data-contract';
import useBasketReference from '~/services/shop/hooks/selectors/basket/useBasketReference';
import { useUserId } from '~/shared/utils/cookie';
import { getCheckout } from '../../operations/checkout';

export default function useCheckout() {
    const [userId] = useUserId();
    const { data: reference } = useBasketReference();

    return useMutation<ShopTypes.CheckoutQueryResult, HTTPError | Error>(
        ['checkout', { reference }],
        () => getCheckout({ reference, userId }),
        {
            retry: false,
        },
    );
}
